import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from './reducers/dashboardSlice';
import formsReducer from './reducers/formsSlice';
import submissionsReducer from './reducers/submissionsSlice';
import syncReducer from './reducers/syncSlice';
import uiReducer from './reducers/uiSlice';
import chatReducer from './reducers/chatSlice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    forms: formsReducer,
    submissions: submissionsReducer,
    sync: syncReducer,
    ui: uiReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'ui/openConfirmationModal',
          'ui/closeConfirmationModal',
          'forms/setFormsSuccess',
          'submissions/setSuccess',
          'dashboard/setStatsSucceeded',
          'sync/updatePendingCount',
        ],
        ignoredPaths: [
          'submissions.items',
          'forms.forms',
          'ui.confirmationModal',
        ],
      },
    }),
});